module.exports = __webpack_public_path__ + "static/assets/1b4ab3c0d886dc7a62258e7a8315e627.png";